module.exports = "/_next/static/images/2-b7a9ebc2327e929b6a076215e9e8d687.jpg";